// extracted by mini-css-extract-plugin
export default {"bodyBolderText":"BodyBolderText_bodyBolderText__y--Pk"};